"use client"

import type React from "react"
import { useState, useEffect } from "react"
import { Card, Typography, Button, Grid, Box, IconButton, Skeleton, CircularProgress } from "@mui/material"
import { motion } from "framer-motion"
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButtons, IonButton, IonIcon, useIonViewWillEnter } from "@ionic/react"
import { refreshOutline } from "ionicons/icons"
import {
  TrendingUp,
  TrendingDown,
  AttachMoney,
  ShoppingCart,
  Group,
  Assessment,
  AccountBalance,
  Receipt,
  Dashboard,
  Analytics,
  Timeline,
  Notifications,
  Settings,
} from "@mui/icons-material"
import {
  LineChart,
  Line,
  AreaChart,
  Area,
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts"
import axios from "axios"
import { requestID, baseUrl, config, getBusinessData, getUser } from "../../common/utils"
import { formatCurrencyN } from "../../common/utils_t"
import { useHistory } from "react-router-dom"
import { User } from "lucide-react"
import { MenuButton } from "../../components/Menu"

// Updated sales data with only sales and customers


interface UserData {
  firstName: string
  middleName: string
  lastName: string
}

const StaffWelcomePage: React.FC = () => {

        const history = useHistory();

        
  const [userData, setUserData] = useState<UserData | null>({ firstName: "John", middleName: "", lastName: "Doe" })
  const [loading, setLoading] = useState(false)
  const [lastRefresh, setLastRefresh] = useState(new Date())
  const [selectedTimeframe, setSelectedTimeframe] = useState("7d")
  const [loaddata, setLoadData] = useState(false); // default true


  const [totalSales, setTotalSales] = useState(0);
  const [totalCustomers, setTotalCustomers] = useState(0);
  const [totalOrders, setTotalOrders] = useState(0);
  const [totalProducts, setTotalProducts] = useState(0);
  const [recentTransactions, setRecentTransactions] = useState<any[]>([]);
  const [status, setStatus] = useState({
    loading: false,
    error: false,
    message: "",
  });


      
useEffect(() => {
 // 2. Check if device validation is required
    //  const roleId = user.role_id || user.roleId || 0;
      const requiresDeviceCheck =  1;//roleId >= 1 && roleId <= 10;
      
      if (requiresDeviceCheck) {
        // Redirect to device check page
        history.push('/folder/device-check');
      } else {
        // No device check required, go to welcome page
       
      }

   }, []);

  useEffect(() => {
    // Simulate loading user data
    const storedData = localStorage.getItem("userData")
    if (storedData) {
      setUserData(JSON.parse(storedData))
    }
  }, [])

  const handleRefresh = () => {
    setLoading(true)
     getDashboard();
    setTimeout(() => {
      setLastRefresh(new Date())
      setLoading(false)
    }, 1000)
  }
//pending_raise_receipt_giftcard_crypto_om/Pending%20Transactions
  const quickMenuItems = [
    // { icon: <Dashboard />, label: "Dashboard", color: "#1976d2", count: null },
    // { icon: <Analytics />, label: "Analytics", color: "#388e3c", count: null },
    { icon: <Receipt />, label: "Expense Posting", color: "#f57c00", link: "ledgerPosting_sales_only/ledgerPosting_sales_only" },
    { icon: <Group />, label: "Account  Reports", color: "#7b1fa2",link:"ledgerReport_sales_only/Account Report"},
    // { icon: <ShoppingCart />, label: "Customers", color: "#d32f2f",  link:"customer-centre/Customer%20Directory"},
    { icon: <AccountBalance />, label: "Search Trans.", color: "#0288d1", link: "accountPage_search_by_code/Search%20Transactions" },
    // { icon: <Notifications />, label: "Alerts", color: "#e91e63", count: "3" },
          { icon: <Notifications />, label: "Verify Trans.", color: "#e91e63", link: "manager-sales-reciept_giftcard/Verify%20Giftcard%20&%20Crypto%20Transactions" },

    { icon: <Settings />, label: "Audit Trans.", color: "#795548", link: "manager-sales-reciept_giftcard_audit/Audit%20Giftcard%20and%20Crypto%20Transactions" },

       { icon: <Notifications />, label: "Crypto PayOut", color: "#388e3c", link: "process_payout_conf_receipt_crypto/Audit%20Crypto%20Payout" },  
        { icon: <Notifications />, label: "Gift PayOut", color: "#d32f2f", link: "process_payout_conf_receipt_giftcard_crypto/Audit%20Processor%20Giftcard%20Payout" },

       { icon: <Dashboard />, label: "Pending Trans.", color: "#1976d2", link: "pending_raise_receipt_giftcard_crypto_om/pendingTransactions" },
  ]

  const timeframeOptions = [
    { value: "24h", label: "24 Hours" },
    { value: "7d", label: "7 Days" },
    { value: "30d", label: "30 Days" },
    { value: "90d", label: "90 Days" },
  ]



   const [totalSalesGiftcard, setTotalSalesGiftcard] = useState(0);
   const [totalSalesCrypto, setTotalSalesCrypto] = useState(0);
const [salesData, setMonthlySales] = useState<any[]>([]);
const [performanceData, setweeklyPerformance] = useState<any[]>([]);
const [hourlyData, sethourlyData] = useState<any[]>([]);
  // Make the function async
  const getDashboard = async () => {

    setStatus({ loading: true, error: false, message: "Loading dashboard..." });

    try {
      setLoadData(false);
      const formData = new FormData();
      formData.append("requestID", requestID()); // make sure requestID() is defined

      const response = await axios.post(
        baseUrl() + "ledgers/getDashboardInfo_sales",
        formData,
        config
      );
console.log("dashboard response", response);
      const data = response.data;

      setTotalSales(data.total_sales || 0);
      setTotalCustomers(data.total_customers || 0);
      setTotalOrders(data.total_orders || 0);
      setTotalProducts(data.total_products || 0);
      setRecentTransactions(data.recent_transactions || []);
      setTotalSalesGiftcard(data.total_sales_giftcard || 0);
      setTotalSalesCrypto(data.total_sales_crypto || 0);
      setMonthlySales(data.monthly_sales || []);
      setweeklyPerformance(data.weekly_sales || []);
      sethourlyData(data.hourly_sales || []);
console.log("Monthly Sales Data:", data.hourly_sales);

      setLoadData(true);
      console.log("Dashboard Data:", recentTransactions);
      setStatus({ loading: false, error: false, message: "Dashboard loaded" });
    } catch (error) {
      console.error("Error fetching dashboard:", error);
      setStatus({ loading: false, error: true, message: "Failed to load dashboard" });
    }
  };

  useIonViewWillEnter(() => {
    getDashboard(); // call the correctly named function
  }, []);
  

     const businessId = getBusinessData()?.business_id;
const roleId = Number(getUser()?.loginData?.roleID);


  const opneLink = (link: string) => {
   history.push(`/folder/${link}`)
  //history.push(`/folder/raise-receipt/AddReceipt`, { 
  }



//   const salesData = [
//   { month: "Jan", sales: 4000, customers: 240 },
//   { month: "Feb", sales: 3000, customers: 221 },
//   { month: "Mar", sales: 2000, customers: 229 },
//   { month: "Apr", sales: 9780, customers: 200 },
//   { month: "May", sales: 1890, customers: 218 },
//   { month: "Jun", sales: 2390, customers: 250 },
// ]

const transactionData = [
  { id: 1, type: "Sale", amount: 1250, customer: "John Doe", time: "2 hours ago", status: "completed" },
  { id: 2, type: "Refund", amount: -320, customer: "Jane Smith", time: "4 hours ago", status: "pending" },
  { id: 3, type: "Sale", amount: 890, customer: "Mike Johnson", time: "6 hours ago", status: "completed" },
  { id: 4, type: "Sale", amount: 2100, customer: "Sarah Wilson", time: "8 hours ago", status: "completed" },
  { id: 5, type: "Refund", amount: -150, customer: "Tom Brown", time: "1 day ago", status: "completed" },
]

// Updated category data for only Crypto and Giftcard
const categoryData = [
  { name: "Crypto N", value:  (Number(totalSalesCrypto || 0)), color: "#8884d8" },
  { name: "Giftcard N", value:  (Number(totalSalesGiftcard || 0)), color: "#82ca9d" },
]
//console.log("Category Data:", categoryData);

// Updated weekly performance data with customers and sales
// const performanceData = [
//   { day: "Mon", customers: 120, sales: 3200 },
//   { day: "Tue", customers: 145, sales: 3800 },
//   { day: "Wed", customers: 98, sales: 2900 },
//   { day: "Thu", customers: 167, sales: 4200 },
//   { day: "Fri", customers: 210, sales: 5100 },
//   { day: "Sat", customers: 189, sales: 6300 },
//   { day: "Sun", customers: 156, sales: 4800 },
// ]

// Updated hourly data with sales and customers instead of visitors and sales
// const hourlyData = [
//   { hour: "00:00", customers: 5, sales: 800 },
//   { hour: "04:00", customers: 3, sales: 450 },
//   { hour: "08:00", customers: 25, sales: 1200 },
//   { hour: "12:00", customers: 48, sales: 2500 },
//   { hour: "16:00", customers: 62, sales: 3100 },
//   { hour: "20:00", customers: 42, sales: 1800 },
// ]


// const businessId = getBusinessData()?.business_id;
// const roleId = Number(getUser()?.loginData?.roleID);

const shouldRedirect =
  businessId === "bus_id_b414c8dd64817f8c9a3e60f9bad83c86" &&
  roleId === 46;

  //const history = useHistory();

useEffect(() => {
  if (shouldRedirect) {
    history.push(
      "/folder/raise-order_gift_card/Giftcard & Crypto Transactions"
    );
  }
}, [shouldRedirect, history]);


  return (
    <IonPage className="pushDown">
      <IonHeader>
        <IonToolbar color="primary">
                    <MenuButton /> {/* This adds the hamburger icon */}

          <IonTitle>

{
  businessId === "bus_id_b414c8dd64817f8c9a3e60f9bad83c86" && roleId === 46
    ? "Welcome"
    : (
        <>📊 Analytics Dashboard </>
      )
}
     
            
            Welcome, {userData ? `${userData.lastName}` : "Staff"}!</IonTitle>
          <IonButtons slot="end">
            <Typography variant="caption" style={{ marginRight: "10px", color: "white" }}>
              Last updated: {lastRefresh.toLocaleTimeString()}
            </Typography>
            <IonButton fill="clear" onClick={handleRefresh} disabled={loading}>
              <IonIcon
                icon={refreshOutline}
                style={{
                  animation: loading ? "spin 1s linear infinite" : "none",
                  color: "white",
                }}
              />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      {/* {console.log('Business ID:', getUser().loginData.roleID)} */}
 {!shouldRedirect ? (

    
        <IonContent>...</IonContent>
 ) : (
       <>
      <IonContent fullscreen>
        <Box
          sx={{
            padding: "20px",
            maxWidth: "1400px",
            margin: "0 auto",
            paddingBottom: "40px",
          }}
        >
          { getBusinessData().business_id == "bus_id_b414c8dd64817f8c9a3e60f9bad83c86" ? (
          
       <>
     
          {/* Quick Menu Section */}
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: "#1976d2" }}>
              🚀 Quick Actions
            </Typography>
            <Grid container spacing={2} sx={{ mb: 4 }}>
              {quickMenuItems.map((item, index) => (
                <Grid item xs={6} sm={4} md={3} lg={1.5} key={index}>
                  <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                    <Card
                  onClick={() => {opneLink(item.link)}}
                      sx={{
                        p: 2,
                        textAlign: "center",
                        cursor: "pointer",
                        backgroundColor: item.color,
                        color: "white",
                        position: "relative",
                        "&:hover": { opacity: 0.9 },
                        minHeight: "80px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                      }}
                    >
                      {item.count && (
                        <Box
                          sx={{
                            position: "absolute",
                            top: -8,
                            right: -8,
                            backgroundColor: "#ff4444",
                            color: "white",
                            borderRadius: "50%",
                            width: 24,
                            height: 24,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {item.count}
                        </Box>
                      )}
                      {item.icon}
                      <Typography variant="caption" display="block" sx={{ mt: 1, fontSize: "11px" }}>
                        {item.label}
                      </Typography>
                    </Card>
                  </motion.div>
                </Grid>
              ))}
            </Grid>
          </motion.div>  </>
   ) : ""}
          {/* Key Metrics Cards */}
   <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <Typography variant="h6" fontWeight="bold" sx={{ mb: 2, color: "#1976d2" }}>
              📊 My Daily Key Performance Indicators
            </Typography>
            <Grid container spacing={3} sx={{ mb: 4 }}>
              <Grid item xs={12} sm={6} md={3}>
                <Card sx={{ p: 3, backgroundColor: "#e3f2fd", borderLeft: "5px solid #1976d2" }}>
                  <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Box>
                      <Typography variant="h5" fontWeight="bold" color="#1976d2">
                                    
 {loaddata ? (
  <Typography variant="h5" fontWeight="bold" color="#7b1fa2">
    {formatCurrencyN(Number(totalSales))}
  </Typography>
) : (
  <CircularProgress size={28} thickness={5} color="secondary" />
)}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        Total Revenue Recieved
                      </Typography>
                    </Box>
                    <AttachMoney sx={{ fontSize: 50, color: "#1976d2", opacity: 0.7 }} />
                  </Box>
                </Card>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <Card sx={{ p: 3, backgroundColor: "#e8f5e8", borderLeft: "5px solid #388e3c" }}>
                  <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Box>
                      <Typography variant="h4" fontWeight="bold" color="#388e3c">
                       
                         
                        {loaddata ? (
  <Typography variant="h5" fontWeight="bold" color="#7b1fa2">
    {totalOrders}
  </Typography>
) : (
  <CircularProgress size={28} thickness={5} color="secondary" />
)}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        Total Orders Made
                      </Typography>
                    </Box>
                    <ShoppingCart sx={{ fontSize: 50, color: "#388e3c", opacity: 0.7 }} />
                  </Box>
                </Card>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <Card sx={{ p: 3, backgroundColor: "#fff3e0", borderLeft: "5px solid #f57c00" }}>
                  <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Box>
                      <Typography variant="h5" fontWeight="bold" color="#f57c00">
                     
                        {loaddata ? (
  <Typography variant="h5" fontWeight="bold" color="#7b1fa2">
    {totalCustomers}
  </Typography>
) : (
  <CircularProgress size={28} thickness={5} color="secondary" />
)}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                         Customer Served 
                      </Typography>
                    </Box>
                    <Group sx={{ fontSize: 50, color: "#f57c00", opacity: 0.7 }} />
                  </Box>
                </Card>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <Card sx={{ p: 3, backgroundColor: "#f3e5f5", borderLeft: "5px solid #7b1fa2" }}>
                  <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Box>
  {loaddata ? (
  <Typography variant="h5" fontWeight="bold" color="#7b1fa2">
    {totalProducts}
  </Typography>
) : (
  <CircularProgress size={28} thickness={5} color="secondary" />
)}
                      <Typography variant="body2" color="textSecondary">
                        Total Product 
                      </Typography>
                    </Box>
                    <Assessment sx={{ fontSize: 50, color: "#7b1fa2", opacity: 0.7 }} />
                  </Box>
                </Card>
              </Grid>
            </Grid>
          </motion.div>

          {/* Charts Section */}
          <Grid container spacing={3} sx={{ mb: 4 }}>
            {/* Sales Trend Chart */}
            <Grid item xs={12} lg={8}>
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
              >
                <Card sx={{ p: 3, backgroundColor: "white", boxShadow: "0 4px 20px rgba(0,0,0,0.1)" }}>
                  <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                    <Typography variant="h6" fontWeight="bold" color="#1976d2">
                      📈 Sales & Customer Trend (6 Months)
                    </Typography>
                    <IconButton onClick={handleRefresh} size="small">
                      <IonIcon icon={refreshOutline} />
                    </IconButton>
                  </Box>
                  <ResponsiveContainer width="100%" height={350}>
                    <AreaChart data={salesData}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                      <XAxis dataKey="month" stroke="#666" />
                      <YAxis stroke="#666" />
                      <Tooltip
                        contentStyle={{
                          backgroundColor: "white",
                          border: "1px solid #ddd",
                          borderRadius: "8px",
                        }}
                      />
                      <Legend />
                      <Area
                        type="monotone"
                        dataKey="sales"
                        stackId="1"
                        stroke="#8884d8"
                        fill="#8884d8"
                        fillOpacity={0.6}
                        name="Sales ($)"
                      />
                      <Area
                        type="monotone"
                        dataKey="customers"
                        stackId="2"
                        stroke="#ff7300"
                        fill="#ff7300"
                        fillOpacity={0.6}
                        name="Customers"
                      />
                    </AreaChart>
                  </ResponsiveContainer>
                </Card>
              </motion.div>
            </Grid>

            {/* Category Distribution */}
            <Grid item xs={12} lg={4}>
              <motion.div
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.5 }}
              >
                <Card sx={{ p: 3, backgroundColor: "white", boxShadow: "0 4px 20px rgba(0,0,0,0.1)" }}>
                  <Typography variant="h6" fontWeight="bold" color="#1976d2" mb={3}>
                    🥧 Sales by Product Type
                  </Typography>
                  <ResponsiveContainer width="100%" height={350}>
                    <PieChart>
                      <Pie
                        data={categoryData}
                        cx="50%"
                        cy="50%"
                        labelLine={false}
                        label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                        outerRadius={100}
                        fill="#8884d8"
                        dataKey="value"
                      >
                        {categoryData.map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={entry.color} />
                        ))}
                      </Pie>
                      <Tooltip />
                      <Legend />
                    </PieChart>
                  </ResponsiveContainer>
                </Card>
              </motion.div>
            </Grid>

            {/* Weekly Performance */}
            <Grid item xs={12} md={6}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.6 }}
              >
                <Card sx={{ p: 3, backgroundColor: "white", boxShadow: "0 4px 20px rgba(0,0,0,0.1)" }}>
                  <Typography variant="h6" fontWeight="bold" color="#1976d2" mb={3}>
                    📅 Weekly Customer & Sales Performance
                  </Typography>
                  <ResponsiveContainer width="100%" height={300}>
                    <BarChart data={performanceData}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                      <XAxis dataKey="day" stroke="#666" />
                      <YAxis stroke="#666" />
                      <Tooltip
                        contentStyle={{
                          backgroundColor: "white",
                          border: "1px solid #ddd",
                          borderRadius: "8px",
                        }}
                      />
                      <Legend />
                      <Bar dataKey="customers" fill="#8884d8" radius={[4, 4, 0, 0]} name="Customers" />
                      <Bar dataKey="sales" fill="#82ca9d" radius={[4, 4, 0, 0]} name="Sales ($)" />
                    </BarChart>
                  </ResponsiveContainer>
                </Card>
              </motion.div>
            </Grid>

            {/* Hourly Sales & Customers */}
            <Grid item xs={12} md={6}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.7 }}
              >
                <Card sx={{ p: 3, backgroundColor: "white", boxShadow: "0 4px 20px rgba(0,0,0,0.1)" }}>
                  <Typography variant="h6" fontWeight="bold" color="#1976d2" mb={3}>
                    🕐 Hourly Sales & Customers
                  </Typography>
                  <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={hourlyData}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                      <XAxis dataKey="hour" stroke="#666" />
                      <YAxis stroke="#666" />
                      <Tooltip
                        contentStyle={{
                          backgroundColor: "white",
                          border: "1px solid #ddd",
                          borderRadius: "8px",
                        }}
                      />
                      <Legend />
                      <Line 
                        type="monotone" 
                        dataKey="customers" 
                        stroke="#ff7300" 
                        strokeWidth={3} 
                        dot={{ r: 6 }} 
                        name="Customers" 
                      />
                      <Line 
                        type="monotone" 
                        dataKey="sales" 
                        stroke="#8884d8" 
                        strokeWidth={3} 
                        dot={{ r: 6 }} 
                        name="Sales ($)" 
                      />
                    </LineChart>
                  </ResponsiveContainer>
                </Card>
              </motion.div>
            </Grid>
          </Grid>

          {/* Recent Transactions */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.8 }}
          >
            <Card sx={{ p: 3, backgroundColor: "white", boxShadow: "0 4px 20px rgba(0,0,0,0.1)" }}>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                <Typography variant="h6" fontWeight="bold" color="#1976d2">
                  💳 Recent Transactions
                </Typography>
              </Box>
              <Box>
                {recentTransactions.map((transaction, index) => (
                  <motion.div
                    key={transaction.id}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.3, delay: index * 0.1 }}
                    whileHover={{ backgroundColor: "#f8f9fa" }}
                    style={{ padding: "16px", borderRadius: "12px", marginBottom: "12px", border: "1px solid #eee" }}
                  >
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                      <Box display="flex" alignItems="center">
                        <Box
                          sx={{
                            width: 48,
                            height: 48,
                            borderRadius: "50%",
                            backgroundColor: transaction.id === transaction.id? "#e8f5e8" : "#ffebee",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            mr: 3,
                          }}
                        >
                          {transaction.id === "Sale" ? (
                            <TrendingUp sx={{ color: "#388e3c", fontSize: 24 }} />
                          ) : (
                            <TrendingDown sx={{ color: "#d32f2f", fontSize: 24 }} />
                          )}
                        </Box>
                        <Box>
                        <Typography variant="body1" fontWeight="bold" style={{ textTransform: "uppercase" }}>
  {transaction.customer_name}
</Typography>
                          <Typography variant="caption" color="textSecondary">
                            {transaction.created_at} • Method Of Payment: {transaction.mode_of_payment}
                          </Typography>
                        </Box>
                      </Box>
                      <Box textAlign="right">
                        <Typography
                          variant="h6"
                          fontWeight="bold"
                          color={transaction.amount_paid > 0 ? "#388e3c" : "#d32f2f"}
                        >
                          {transaction.amount_paid > 0 ? "+" : ""}N{Math.abs(transaction.amount_paid).toLocaleString()}
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                         Balance Due: {transaction.balance_due}
                        </Typography>
                      </Box>
                    </Box>
                  </motion.div>
                ))}
              </Box>
            </Card>
          </motion.div>
        </Box>

        <style jsx>{`
          @keyframes spin {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }
        `}</style>
      </IonContent>
 </>)}
    </IonPage>
  )
}

export default StaffWelcomePage